export default [
  {
    path: "/marina",
    component: () => import("../layout/PageLayoutWithoutContainer.vue"),
    children: [
      {
        path: "",
        name: "Marina Form",
        component: () => import("@/views/Marina/Marina.vue")
      }
    ]
  }
];
